import type { WireArticleBlock } from '../../../api/types'

type Block = Extract<WireArticleBlock, { type: 'warning' }>

export function WarningBlock({ block }: { block: Block }) {
  return (
    <div
      role="note"
      className="rounded border border-warning-line bg-warning-fill px-4 py-3 text-sm font-semibold text-warning-fg"
    >
      {block.content}
    </div>
  )
}
